import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle, ChevronsUpDown, Check } from 'lucide-react';
import { AnimatedShaderHero } from '@/components/ui/animated-shader-hero';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

const countryCodes = [
  { code: '+1', country: 'US', label: 'United States' },
  { code: '+44', country: 'GB', label: 'United Kingdom' },
  { code: '+91', country: 'IN', label: 'India' },
  { code: '+49', country: 'DE', label: 'Germany' },
  { code: '+33', country: 'FR', label: 'France' },
  { code: '+61', country: 'AU', label: 'Australia' },
  { code: '+1', country: 'CA', label: 'Canada' },
  { code: '+971', country: 'AE', label: 'UAE' },
  { code: '+86', country: 'CN', label: 'China' },
  { code: '+81', country: 'JP', label: 'Japan' },
  { code: '+82', country: 'KR', label: 'South Korea' },
  { code: '+65', country: 'SG', label: 'Singapore' },
  { code: '+55', country: 'BR', label: 'Brazil' },
  { code: '+52', country: 'MX', label: 'Mexico' },
  { code: '+234', country: 'NG', label: 'Nigeria' },
  { code: '+27', country: 'ZA', label: 'South Africa' },
  { code: '+966', country: 'SA', label: 'Saudi Arabia' },
  { code: '+31', country: 'NL', label: 'Netherlands' },
  { code: '+46', country: 'SE', label: 'Sweden' },
  { code: '+47', country: 'NO', label: 'Norway' },
  { code: '+45', country: 'DK', label: 'Denmark' },
  { code: '+358', country: 'FI', label: 'Finland' },
  { code: '+34', country: 'ES', label: 'Spain' },
  { code: '+39', country: 'IT', label: 'Italy' },
  { code: '+41', country: 'CH', label: 'Switzerland' },
  { code: '+43', country: 'AT', label: 'Austria' },
  { code: '+48', country: 'PL', label: 'Poland' },
  { code: '+420', country: 'CZ', label: 'Czech Republic' },
  { code: '+353', country: 'IE', label: 'Ireland' },
  { code: '+351', country: 'PT', label: 'Portugal' },
  { code: '+32', country: 'BE', label: 'Belgium' },
  { code: '+852', country: 'HK', label: 'Hong Kong' },
  { code: '+60', country: 'MY', label: 'Malaysia' },
  { code: '+66', country: 'TH', label: 'Thailand' },
  { code: '+62', country: 'ID', label: 'Indonesia' },
  { code: '+63', country: 'PH', label: 'Philippines' },
  { code: '+84', country: 'VN', label: 'Vietnam' },
  { code: '+880', country: 'BD', label: 'Bangladesh' },
  { code: '+92', country: 'PK', label: 'Pakistan' },
  { code: '+20', country: 'EG', label: 'Egypt' },
  { code: '+254', country: 'KE', label: 'Kenya' },
  { code: '+64', country: 'NZ', label: 'New Zealand' },
];

export default function HeroSection() {
 const [submitted, setSubmitted] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);

const [formData, setFormData] = useState({
  name: "",
  email: "",
  company: "",
  phone: "",
  message: ""
});

const [errors, setErrors] = useState({});
const [agree, setAgree] = useState(false);
const [countryCode, setCountryCode] = useState("+1-US");
const [countryOpen, setCountryOpen] = useState(false);
const selectedCountry = countryCodes.find(
  (c) => `${c.code}-${c.country}` === countryCode
);

// const validate = () => {
//   const newErrors = {};

//   if (!formData.name.trim()) {
//     newErrors.name = "Full name is required";
//   }

//   if (!formData.email.trim()) {
//     newErrors.email = "Business email required";
//   } else {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     const blockedDomains = [
//       "gmail.com",
//       "yahoo.com",
//       "outlook.com",
//       "hotmail.com",
//       "live.com",
//       "icloud.com"
//     ];

//     const domain = formData.email.split("@")[1]?.toLowerCase();

//     if (!emailRegex.test(formData.email)) {
//       newErrors.email = "Invalid email";
//     } else if (blockedDomains.includes(domain)) {
//       newErrors.email = "Use company email only";
//     }
//   }

//   if (!formData.company.trim()) {
//     newErrors.company = "Company required";
//   }

//   if (!formData.phone.trim()) {
//     newErrors.phone = "Phone required";
//   }

//   if (!formData.message.trim()) {
//     newErrors.message = "Message required";
//   }

//   setErrors(newErrors);

//   return Object.keys(newErrors).length === 0;
// };

// const validate = () => {
//   const newErrors = {};

//   if (!formData.name.trim()) {
//     newErrors.name = "Full name is required";
//   }

//   if (!formData.email.trim()) {
//     newErrors.email = "Business email required";
//   } else {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     const blockedDomains = [
//       "gmail.com",
//       "yahoo.com",
//       "outlook.com",
//       "hotmail.com",
//       "live.com",
//       "icloud.com"
//     ];

//     const domain = formData.email.split("@")[1]?.toLowerCase();

//     if (!emailRegex.test(formData.email)) {
//       newErrors.email = "Invalid email";
//     } else if (blockedDomains.includes(domain)) {
//       newErrors.email = "Use company email only";
//     }
//   }

//   if (!formData.company.trim()) {
//     newErrors.company = "Company required";
//   }

//   if (!formData.phone.trim()) {
//     newErrors.phone = "Phone required";
//   }

//   if (!formData.message.trim()) {
//     newErrors.message = "Message required";
//   }

//   // ✅ checkbox validation
//   if (!agree) {
//     newErrors.agree = "You must accept the Privacy Policy";
//   }

//   setErrors(newErrors);

//   return Object.keys(newErrors).length === 0;
// };

const validate = () => {
  const newErrors = {};

  if (!formData.name.trim()) {
    newErrors.name = "Please enter your full name.";
  }

  if (!formData.email.trim()) {
    newErrors.email = "Please enter your business email address.";
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const blockedDomains = [
      "gmail.com",
      "yahoo.com",
      "outlook.com",
      "hotmail.com",
      "live.com",
      "icloud.com"
    ];

    const domain = formData.email.split("@")[1]?.toLowerCase();

    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    } else if (blockedDomains.includes(domain)) {
      newErrors.email = "Please use your company email address (free email providers are not accepted).";
    }
  }

  if (!formData.company.trim()) {
    newErrors.company = "Please enter your company name.";
  }

  if (!formData.phone.trim()) {
    newErrors.phone = "Please enter your phone number.";
  }

  if (!formData.message.trim()) {
    newErrors.message = "Please provide a brief message about your requirements.";
  }

  if (!agree) {
    newErrors.agree = "You must accept the Privacy Policy before submitting the form.";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};


 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validate()) return;

  setIsSubmitting(true);
  setSubmitted(true);

  const selected = countryCodes.find(
    c => `${c.code}-${c.country}` === countryCode
  );

  const formPayload = new FormData();

  formPayload.append("name", formData.name);
  formPayload.append("email", formData.email);
  formPayload.append("company", formData.company);
  formPayload.append("phone", `${selected.code}${formData.phone}`);
  formPayload.append("message", formData.message);

  fetch("https://itmunch.com/b2b-content-syndication-services/send-mail.php", {
    method: "POST",
    body: formPayload,
  }).catch(err => console.error(err));

  // setFormData({
  //   name: "",
  //   email: "",
  //   company: "",
  //   phone: "",
  //   message: ""
  // });

  // setErrors({});
  // setIsSubmitting(false);
  setFormData({
  name: "",
  email: "",
  company: "",
  phone: "",
  message: ""
});

setAgree(false); // reset checkbox
setErrors({});
setIsSubmitting(false);
};

  return (
    <AnimatedShaderHero>
      <div
        id="hero"
        data-testid="hero-section"
        className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-[100px] md:pt-[100px] pb-6"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          {/* Left - Content */}
          <div>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-[#4AC5DB]/15 border border-[#4AC5DB]/30 backdrop-blur-xl shadow-lg mb-8"
            >
              <div className="w-2 h-2 bg-[#4AC5DB] rounded-full animate-ping" />
              <span className="relative z-10 text-sm font-bold text-[#4AC5DB] tracking-wider uppercase">
                Trusted by 90+ Global Brands
              </span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.3 }}
              data-testid="hero-headline"
              className="font-['Outfit'] text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight leading-[1.05] text-white mb-6"
            >
              Leading B2B{' '}
              <span className="relative inline-block">
                <span className="bg-gradient-to-r from-[#4AC5DB] via-[#5DD8EC] to-[#3198A8] bg-clip-text text-transparent">
                  Content Syndication
                </span>
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: '100%' }}
                  transition={{ duration: 1.5, delay: 1.2, ease: 'easeOut' }}
                  className="absolute -bottom-2 left-0 h-1.5 bg-gradient-to-r from-[#4AC5DB] via-[#4AC5DB]/80 to-transparent rounded-full shadow-lg shadow-[#4AC5DB]/30"
                />
              </span>{' '}
              Service Provider
            </motion.h1>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              data-testid="hero-subtitle"
              className="text-lg md:text-xl text-slate-300 leading-relaxed max-w-xl mb-8"
            >
              Amplify your reach and generate qualified leads across{' '}
              <span className="text-white font-semibold">
                1,500+ platforms
              </span>. Connect with decision-makers and drive measurable business growth.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1 }}
              className="flex flex-wrap gap-6 mb-8"
            >
              {['24-Hour Turnaround', '1M+ Monthly Reach', 'Data-Driven Targeting'].map((item) => (
                <div key={item} className="flex items-center gap-2 text-sm text-slate-300">
                  <CheckCircle className="w-5 h-5 text-[#4AC5DB]" />
                  <span className="font-medium">{item}</span>
                </div>
              ))}
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1.2 }}
              className="hidden lg:flex"
            >
              <Button
                data-testid="hero-cta-button"
                className="group rounded-full bg-[#4AC5DB] hover:bg-[#3AB0C5] text-white px-8 h-13 text-base font-semibold shadow-xl shadow-[#4AC5DB]/25 transition-all hover:-translate-y-0.5"
                onClick={() => document.querySelector('[data-testid="form-full-name"]')?.focus()}
              >
                Get Started Now
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </motion.div>
          </div>

          {/* Right - Form */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            <div className="bg-white rounded-2xl shadow-2xl shadow-black/30 p-6 sm:p-8">
              <h2 className="font-['Outfit'] text-xl font-semibold text-slate-900 mb-1">
                Start Your Campaign Today
              </h2>
              <p className="text-sm text-slate-500 mb-6">
                Fill in your details and our team will reach out within 24 hours.
              </p>

              {submitted ? (
                <div data-testid="form-success-message" className="text-center py-12">
                  <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4">
                    <CheckCircle className="w-8 h-8 text-emerald-500" />
                  </div>
                  <h3 className="font-['Outfit'] text-xl font-semibold text-slate-900 mb-2">Thank You!</h3>
                  <p className="text-sm text-slate-500">We'll get back to you within 24 hours.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} data-testid="lead-capture-form" className="space-y-4">
                  <div>
                    <Label htmlFor="fullName" className="text-slate-700 text-sm font-medium">
                      Full Name <span className="text-red-400">*</span>
                    </Label>
                    {/* <Input
                      id="fullName"
                      data-testid="form-full-name"
                      placeholder="John Smith"
                      required
                      className="mt-1.5 h-11 rounded-lg border-slate-200 focus:border-[#4AC5DB] focus:ring-[#4AC5DB] bg-white"
                    /> */}
                    <Input
  id="fullName"
  placeholder="John Smith"
  value={formData.name}
  onChange={(e)=>setFormData({...formData,name:e.target.value})}
  className={`mt-1.5 h-11 ${errors.name ? "border-red-500" : ""}`}
/>
{errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
                  </div>

                  <div>
                    <Label htmlFor="email" className="text-slate-700 text-sm font-medium">
                      Business Email <span className="text-red-400">*</span>
                    </Label>
                    {/* <Input
                      id="email"
                      type="email"
                      data-testid="form-email"
                      placeholder="john@company.com"
                      required
                      className="mt-1.5 h-11 rounded-lg border-slate-200 focus:border-[#4AC5DB] focus:ring-[#4AC5DB] bg-white"
                    /> */}
                    <Input
  id="email"
  type="email"
  placeholder="john@company.com"
  value={formData.email}
  onChange={(e)=>setFormData({...formData,email:e.target.value})}
  className={`mt-1.5 h-11 ${errors.email ? "border-red-500" : ""}`}
/>
{errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
                    <p className="text-xs text-slate-400 mt-1">Business emails only. Free domains not accepted.</p>
                  </div>

                  <div>
                    <Label htmlFor="company" className="text-slate-700 text-sm font-medium">
                      Company Name <span className="text-red-400">*</span>
                    </Label>
                    {/* <Input
                      id="company"
                      data-testid="form-company"
                      placeholder="Acme Corp"
                      required
                      className="mt-1.5 h-11 rounded-lg border-slate-200 focus:border-[#4AC5DB] focus:ring-[#4AC5DB] bg-white"
                    /> */}
                    <Input
  id="company"
  placeholder="Acme Corp"
  value={formData.company}
  onChange={(e)=>setFormData({...formData,company:e.target.value})}
  className={`mt-1.5 h-11 ${errors.company ? "border-red-500" : ""}`}
/>
{errors.company && <p className="text-red-500 text-xs">{errors.company}</p>}
                  </div>

                  <div>
                    <Label className="text-slate-700 text-sm font-medium">
                      Phone Number <span className="text-red-400">*</span>
                    </Label>
                    <div className="flex gap-2 mt-1.5">
                      <Popover open={countryOpen} onOpenChange={setCountryOpen}>
                        <PopoverTrigger asChild>
                          <Button
                            variant="outline"
                            role="combobox"
                            aria-expanded={countryOpen}
                            data-testid="form-country-trigger"
                            className="w-[120px] h-11 rounded-lg border-slate-200 bg-white shrink-0 justify-between font-normal text-sm hover:bg-slate-50"
                          >
                            {selectedCountry ? `${selectedCountry.code} ${selectedCountry.country}` : '+1 US'}
                            <ChevronsUpDown className="ml-1 h-3.5 w-3.5 shrink-0 opacity-50" />
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent className="w-[240px] p-0" align="start" data-testid="form-country-dropdown">
                          <Command>
                            <CommandInput
                              placeholder="Search country..."
                              data-testid="country-search-input"
                              className="h-9"
                            />
                            <CommandList>
                              <CommandEmpty>No country found.</CommandEmpty>
                              <CommandGroup className="max-h-[200px] overflow-y-auto">
                                {countryCodes.map((c) => {
                                  const val = `${c.code}-${c.country}`;
                                  return (
                                    <CommandItem
                                      key={val}
                                      value={`${c.label} ${c.country} ${c.code}`}
                                      data-testid={`country-option-${c.country.toLowerCase()}`}
                                      onSelect={() => {
                                        setCountryCode(val);
                                        setCountryOpen(false);
                                      }}
                                      className="cursor-pointer"
                                    >
                                      <Check
                                        className={`mr-2 h-4 w-4 ${countryCode === val ? 'opacity-100 text-[#4AC5DB]' : 'opacity-0'}`}
                                      />
                                      <span className="font-medium">{c.code}</span>
                                      <span className="ml-2 text-slate-500">{c.label}</span>
                                    </CommandItem>
                                  );
                                })}
                              </CommandGroup>
                            </CommandList>
                          </Command>
                        </PopoverContent>
                      </Popover>
                      {/* <Input
                        type="tel"
                        data-testid="form-phone"
                        placeholder="Phone number"
                        required
                        className="flex-1 h-11 rounded-lg border-slate-200 focus:border-[#4AC5DB] focus:ring-[#4AC5DB] bg-white"
                      /> */}
                      <div class="flex-1">
                    <Input
  type="tel"
  placeholder="Phone number"
  value={formData.phone}
  onChange={(e)=>setFormData({...formData,phone:e.target.value.replace(/\D/g,"")})}
  className={` h-11 ${errors.phone ? "border-red-500" : ""}`}
/>
{errors.company && <p className="text-red-500 text-xs">{errors.phone}</p>}
                    </div>
                    </div>
                  </div>

                  <div>
                    <Label htmlFor="message" className="text-slate-700 text-sm font-medium">
                      Message <span className="text-red-400">*</span>
                    </Label>
                    {/* <Textarea
                      id="message"
                      data-testid="form-message"
                      placeholder="Tell us about your content syndication goals..."
                      required
                      rows={3}
                      className="mt-1.5 rounded-lg border-slate-200 focus:border-[#4AC5DB] focus:ring-[#4AC5DB] bg-white resize-none"
                    /> */}
                  <Textarea
  value={formData.message}
  onChange={(e)=>setFormData({...formData,message:e.target.value})}
  rows={3}
  placeholder="Tell us about your content syndication goals..."
  className={`mt-1.5 rounded-lg ${errors.message ? "border-red-500" : ""}`}
/>
{errors.message && <p className="text-red-500 text-xs">{errors.message}</p>}
                  </div>

                  {/* <p className="text-xs text-slate-400">
                    By submitting, you agree to our{' '}
                    <a href="https://itmunch.com/privacy-policy/" className="text-[#4AC5DB] hover:underline" target="_blank" rel="noopener noreferrer">
                      Privacy Policy
                    </a>.
                  </p> */}
                  <div className="flex items-start gap-2">
  <input
    type="checkbox"
    checked={agree}
    onChange={(e) => setAgree(e.target.checked)}
    className="mt-1 accent-[#4AC5DB]"
  />

  <p className="text-xs text-slate-400">
    By submitting, you agree to our{" "}
    <a
      href="https://itmunch.com/privacy-policy/"
      className="text-[#4AC5DB] hover:underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>.
  </p>
</div>

{errors.agree && (
  <p className="text-red-500 text-xs">{errors.agree}</p>
)}


                  {/* <Button
                    type="submit"
                    data-testid="form-submit-button"
                    className="w-full rounded-full bg-[#4AC5DB] hover:bg-[#3AB0C5] text-white h-12 text-base font-semibold shadow-lg shadow-[#4AC5DB]/20 transition-all hover:-translate-y-0.5 active:scale-[0.98]"
                  >
                    Get Started Now <ArrowRight className="w-5 h-5 ml-2" />
                  </Button> */}
                  <Button
  type="submit"
  disabled={isSubmitting}
  className="w-full rounded-full bg-[#4AC5DB] text-white h-12"
>
  {isSubmitting ? "Submitting..." : "Get Started Now"}
</Button>
                </form>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </AnimatedShaderHero>
  );
}
